import * as React from 'react';
import SearchForm  from './SearchForm';

export default function Home() {
  return (
    <SearchForm />
  );
}